import LegalLayout, { COMPANY, EMAIL } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Política de Privacidad">
      <p>{COMPANY} ("nosotros", "nuestro") opera la plataforma Hephy 3D, un personalizador 3D de joyería y prendas para tiendas (B2B). Esta política explica qué datos recopilamos, cómo los usamos y tus derechos. Al usar la plataforma aceptas esta política.</p>

      <h2>1. Información que recopilamos</h2>
      <ul>
        <li><b>Datos de cuenta:</b> nombre, correo electrónico, nombre del negocio y contraseña (cifrada).</li>
        <li><b>Contenido que subes:</b> imágenes de referencia, logos, modelos 3D (OBJ/GLB/STL) y configuraciones de producto.</li>
        <li><b>Datos de integraciones:</b> tokens de acceso de Wix, Shopify y Google que autorizas expresamente (almacenados de forma cifrada).</li>
        <li><b>Datos de facturación:</b> gestionados por Stripe; no almacenamos números de tarjeta en nuestros servidores.</li>
        <li><b>Datos de uso:</b> registros técnicos, direcciones IP y eventos de la aplicación para seguridad y mejora del servicio.</li>
      </ul>

      <h2>2. Uso de datos de Google (Gmail API)</h2>
      <p>Si conectas tu cuenta de Google, usamos el permiso <code>gmail.send</code> <b>únicamente</b> para enviar, en tu nombre, los correos de diseño/pedido a tus clientes. No leemos, almacenamos ni compartimos el contenido de tu bandeja de entrada. El uso y la transferencia de la información recibida de las APIs de Google se ajustan a la <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noreferrer">Política de Datos de Usuario de los Servicios de API de Google</a>, incluidos sus requisitos de Uso Limitado. Puedes revocar el acceso en cualquier momento desde Ajustes o en tu cuenta de Google.</p>

      <h2>3. Cómo usamos la información</h2>
      <ul>
        <li>Proveer y operar el personalizador 3D y el visor.</li>
        <li>Sincronizar productos con Wix/Shopify y procesar comisiones vía Stripe.</li>
        <li>Enviar correos transaccionales y de soporte.</li>
        <li>Prevenir fraude y garantizar la seguridad.</li>
      </ul>

      <h2>4. Compartición con terceros</h2>
      <p>Compartimos datos solo con proveedores necesarios para operar el servicio: Stripe (pagos), Wix y Shopify (según tus integraciones), Google (envío de correo), y proveedores de generación 3D e IA que tú configures. No vendemos tus datos personales.</p>

      <h2>5. Retención y eliminación</h2>
      <p>Conservamos los datos mientras tu cuenta esté activa. Puedes solicitar la eliminación de tu cuenta y datos en cualquier momento (ver <a href="/data-deletion">Eliminación de datos</a>).</p>

      <h2>6. Seguridad</h2>
      <p>Ciframos las credenciales sensibles y usamos conexiones seguras (HTTPS). Ningún método de transmisión es 100% seguro, pero aplicamos salvaguardas razonables.</p>

      <h2>7. Tus derechos</h2>
      <p>Según tu jurisdicción (incluidas leyes de EE. UU. y GDPR/CCPA cuando aplique), puedes acceder, corregir, exportar o eliminar tus datos, y oponerte a ciertos tratamientos. Escríbenos a <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>

      <h2>8. Menores</h2>
      <p>El servicio está dirigido a empresas y no está destinado a menores de 18 años.</p>

      <h2>9. Cambios</h2>
      <p>Podemos actualizar esta política; publicaremos la versión vigente con su fecha. El uso continuado implica aceptación.</p>

      <h2>10. Contacto</h2>
      <p>{COMPANY} — <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>
    </LegalLayout>
  );
}
